
// Define the prompts for each dice roll
export const journalPrompts = {
  1: {
    perception: "What noise, silence, or sound is pulling at you?",
    intention: "What part of this problem is too loud—or not loud enough?",
    nextStep: "How might you adjust the volume on this situation?",
  },
  2: {
    perception: "What physical sensation—tension, pressure, or discomfort is pulling at you?",
    intention: "How does this problem show up in your body? What might it be telling you?",
    nextStep: "What physical shift might help you move forward?",
  },
  3: {
    perception: "What movement urge—or resistance to move is pulling at you?",
    intention: "Is there something you've wanted to do—but keep stopping short of?",
    nextStep: "What small physical action could you take now?",
  },
  4: {
    perception: "What looping thought or spiraling question is pulling at you?",
    intention: "What story keeps repeating in your head about this? Where does it break?",
    nextStep: "How might you reframe this thought pattern?",
  },
  5: {
    perception: "What in your space feels off or is pulling at you?",
    intention: "Is your environment reinforcing the stuckness? What object keeps looking back at you?",
    nextStep: "How could you adjust your environment to support a shift?",
  },
  6: {
    perception: "What name, memory, or someone else's voice is pulling at you?",
    intention: "Is this about what you think, or what someone else expects? Who's in the room with you—even if they're not here?",
    nextStep: "How might you respond differently to this voice or expectation?",
  },
};

export const twistPrompts = {
  1: {
    title: "Breathe with it",
    prompt: "Take a slow breath. Now reread the prompt—what feels different?"
  },
  2: {
    title: "Zoom out",
    prompt: "Imagine this prompt belongs to someone else. What advice would you give them?"
  },
  3: {
    title: "Turn it tactile",
    prompt: "Find an object nearby. How does this prompt feel in your hands?"
  },
  4: {
    title: "Flip the frame",
    prompt: "What's the opposite of what this prompt is pointing to? What do you notice?"
  },
  5: {
    title: "Bring someone in",
    prompt: "Who would you ask about this? Even hypothetically—what would they say?"
  },
  6: {
    title: "Time travel",
    prompt: "How would Past You or Future You respond to this prompt right now?"
  }
};

export const lensFocusPrompts = {
  "1minute": {
    title: "1-Minute Focus",
    prompt: "Set a timer for exactly one minute. Write continuously without stopping until the timer goes off."
  },
  "location": {
    title: "Location Lens",
    prompt: "Notice where you are in physical space right now. How does this place affect what you're thinking about?"
  },
  "sensory": {
    title: "Sensory Lens",
    prompt: "Pay attention to one specific bodily sensation. How does it relate to what you're working through?"
  },
  "emotional": {
    title: "Emotional Lens",
    prompt: "What's the core feeling beneath all your thinking about this? Name it as specifically as you can."
  }
};

export default journalPrompts;
